import { QueryResource, QueryResources } from 'datx-jsonapi-react';

import { GoogleScholarTags } from '@/resources/GoogleScholarTags';

export const getScholarTagsForLectureId = (id: string): QueryResource<GoogleScholarTags> => {
  if (!id) return null;
  return [GoogleScholarTags, undefined, { filter: { id } }];
};
